var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whatsapp d-flex align-items-center",attrs:{"href":`https://wa.me/4915140703001/${_vm.urlText ? `?text=${_vm.urlText}` : ''}`,"target":_vm.target}},[_c('font-awesome-icon',{attrs:{"icon":"fa-brands fa-whatsapp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }